import { getCDNAssetURL } from "../utils/web-helper";
const cdnAssetUrl = getCDNAssetURL();

export const UnsupportedLandscapeImg = `${cdnAssetUrl}/assets/student-dashboard-images/unsupported-landscape-image.svg`;
export const PlayPauseButton = `${cdnAssetUrl}/assets/icons/play-pause.png`;
export const GreaterTime = `${cdnAssetUrl}/assets/images/dashboard/greater_time.svg`;
export const LessTime = `${cdnAssetUrl}/assets/images/dashboard/less_time.svg`;
export const StopWatch = `${cdnAssetUrl}/assets/images/dashboard/stop_watch.svg`;
export const LiveClassBgImages = `${cdnAssetUrl}/assets/topics_out`;
export const DefaultLiveClassBgImage = `${cdnAssetUrl}/assets/topics_out/live_class_outside_the_box.svg`;
export const TickImage = `${cdnAssetUrl}/assets/live_class/time_preference_popup/tick.svg`;
export const ChevronIcon = `${cdnAssetUrl}/assets/icons/chevron-purple.svg`;
export const YellowLineImage = `${cdnAssetUrl}/summer_theme/yellow-curled-line.svg`
export const SummerSun = `${cdnAssetUrl}/summer_theme/sun.svg`
export const FullSummerSun = `${cdnAssetUrl}/assets/summer_theme/sun.svg`;
export const sunSeeingLeft = `${cdnAssetUrl}/assets/summer_theme/sun_see_left.svg`;

export const voiceOverUrlToAccessGrownUpArea = `${cdnAssetUrl}/web_assets/sounds/world_design_grown_up_en.mp3`;
export const LiveClassQuestionImages = `${cdnAssetUrl}/assets/dashboard/topics_out`;